import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Color, LegendPosition, ScaleType} from '@swimlane/ngx-charts';

@Component({
  selector: 'app-macronutrient-charts',
  templateUrl: './macronutrient-charts.component.html',
  styleUrls: ['./macronutrient-charts.component.scss']
})
export class MacronutrientChartsComponent implements OnInit, OnChanges {
  @Input() kcal: number;

  /**
   * Propiedad usada para quitar el contenedor de la tarjeta
   */
  @Input() withoutContainer = false;
  @Input() data: any[];
  @Input() view: any[];
  @Input() title = 'Macronutrientes';
  @Input() description = 'Distribución de macronutrientes';
  @Input() emptyText = 'No hay datos';
  @Input() colorSchemeMacronutrients: Color = {
    name: '',
    selectable: false,
    group: ScaleType.Linear,
    domain: ['#f6e58d', '#22a6b3', '#eb4d4b', '#3498db']
  };
  hasData = false;
  legendPosition = LegendPosition;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.data) return;
    for (const data of this.data) {
      if (data.value > 0) {
        this.hasData = true;
      }
    }
  }
}
